import { type ReactNode, useRef } from 'react';
import { Button, type ButtonVariant } from './button';

/** A button that opens the file chooser — the only file input in the app. */
export function FileButton({
  accept,
  onFile,
  label,
  variant = 'secondary',
  icon,
  children,
}: {
  accept: string;
  onFile: (file: File) => void;
  label: string;
  variant?: ButtonVariant;
  icon?: string;
  children?: ReactNode;
}) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={input}
        type="file"
        accept={accept}
        hidden
        aria-label={label}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFile(file);
          e.target.value = '';
        }}
      />
      <Button
        variant={variant}
        size="sm"
        icon={icon}
        square={!children}
        aria-label={children ? undefined : label}
        title={label}
        onClick={() => input.current?.click()}
      >
        {children}
      </Button>
    </>
  );
}
